import useLanguage from "../../i18n/useLanguage";

export default function AiProductPreview({ product }) {
  const { t } = useLanguage();
  return (
    <div className="relative h-52 sm:h-60 overflow-hidden border-b border-white/10">
      <img src="/examples/ai/photo-1.webp" alt={t("Tumbler panda dengan latar hutan bambu")} width="900" height="1600" loading="lazy" className="h-full w-full object-cover object-[center_55%]" />
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-black/50" />
      <span className="absolute left-6 top-5 text-xs uppercase tracking-[0.2em] text-white">{t(product.category)}</span>
      <span className="absolute left-6 bottom-5 text-xl font-bold tracking-[0.16em] text-white">{t(product.visual)}</span>
    </div>
  );
}
